import React, { useState, useEffect, useCallback, useRef } from "react";
import { createCategory, getUserById, updateCategory } from "../../apis";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import actions from "../../actions";
import "./categories.css";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Pagination from "@mui/material/Pagination"; // Using MUI Pagination
import { FiMoreVertical } from "react-icons/fi"; // Icon for dropdown actions

const CategoryPage = ({
  stopLoadingRequest,
  startLoadingRequest,
  activateModal,
  deactivateModal,
}) => {
  const [categories, setCategories] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { id } = useParams();
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [stylePreference, setStylePreference] = useState("Men");
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const dropdownRefs = useRef([]);

  // Pagination and Search States
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // Reset page when search term changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const fetchCategories = useCallback(async () => {
    try {
      startLoadingRequest();
      const apiResponse = await getUserById(id);
      setCategories(apiResponse?.data?.data?.categories || []);
    } catch (error) {
      setCategories([]);
    } finally {
      stopLoadingRequest();
    }
  }, [startLoadingRequest, stopLoadingRequest, id]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  const handleAddCategory = () => {
    setSelectedCategory("");
    setCategoryName("");
    setIsModalOpen(true);
  };

  const handleEditCategory = async (category) => {
    setSelectedCategory(category._id);
    setCategoryName(category.name);
    setStylePreference(category.stylePreference);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const predefinedStylePreferences = ["Men", "Women", "Unisex"];

  const createNewCategory = async () => {
    try {
      const formData = {
        userId: id,
        name: categoryName,
        stylePreference,
      };
      const response = await createCategory(formData);
      if (response && response.data) {
        await fetchCategories();
        toast.success("Category created successfully!");
        closeModal();
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      toast.error("Error creating category. Please try again.");
    } finally {
      stopLoadingRequest();
    }
  };

  const updateExistingCategory = async () => {
    try {
      const formData = {
        name: categoryName,
        categoryId: selectedCategory,
        stylePreference,
      };
      const response = await updateCategory(formData);
      if (response && response.data) {
        await fetchCategories();
        toast.success("Category updated successfully!");
        closeModal();
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      toast.error("Error updating Category. Please try again.");
    } finally {
      stopLoadingRequest();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    startLoadingRequest();
    if (selectedCategory) {
      updateExistingCategory();
    } else {
      createNewCategory();
    }
  };

  const toggleDropdown = (index) => {
    setDropdownOpen(dropdownOpen === index ? null : index);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefs.current &&
        !dropdownRefs.current.some((ref) => ref && ref.contains(event.target))
      ) {
        setDropdownOpen(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Filter categories based on search term (by name or style preference)
  const filteredCategories = categories.filter((cat) =>
    (cat.name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    (cat.stylePreference || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination helper: slice items based on currentPage and rowsPerPage
  const paginateItems = (items) => {
    const indexOfLastItem = currentPage * rowsPerPage;
    const indexOfFirstItem = indexOfLastItem - rowsPerPage;
    return items.slice(indexOfFirstItem, indexOfLastItem);
  };

  const computedTotalPages = Math.ceil(filteredCategories.length / rowsPerPage);
  const displayedCategories = paginateItems(filteredCategories);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <div style={{ position: "relative", background: "transparent" }} className="category-list">
      <div
        className="header"
        style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}
      >
        <h2>
          {searchTerm.trim() === ""
            ? "Category Items"
            : filteredCategories.length > 0
            ? <>Results for <span className="highlight">{searchTerm}</span></>
            : "0 Categories Found!"}
        </h2>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search Categories..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      {/* <button className="add-category-button" id="add-category-button-color" onClick={handleAddCategory}>
        Add Category
      </button> */}
      <div className="table-container">
        <table className="wardrobe-table" id="category-table-color">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Category Name</th>
              <th>Item Count</th>
              {/* <th>Actions</th> */}
            </tr>
          </thead>
          <tbody>
            {displayedCategories?.map((category, index) =>
              category ? (
                <tr key={category._id}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{category.name}</td>
                  <td>{category.wardrobeCount}</td>
                  {/* <td>
                    <div className="table-actions" ref={(el) => (dropdownRefs.current[index] = el)}>
                      <div className="dropdown">
                        <FiMoreVertical
                          size={24}
                          onClick={() => toggleDropdown(index)}
                          className="dropdown-icon"
                        />
                        {dropdownOpen === index && (
                          <div className="dropdown-menu">
                            <button
                              onClick={() => {
                                toggleDropdown(null);
                                handleEditCategory(category);
                              }}
                              className="dropdown-item"
                            >
                              Edit
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </td> */}
                </tr>
              ) : null
            )}
          </tbody>
        </table>
    
        <div className="pagination" style={{alignItems:'center'}}><Pagination count={computedTotalPages} page={currentPage} onChange={handlePageChange} color="primary" /></div>

      </div>
   

      {isModalOpen && (
        <div
          style={{
            zIndex: "10000",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            backdropFilter: "blur(10px)",
          }}
        >
          <div
            className="modal-content"
            style={{
              borderRadius: "8px",
              padding: "30px",
              width: "100%",
              maxWidth: "600px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              fontFamily: "'DM Sans', sans-serif",
              backgroundColor: "#e5e5e5",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
              <h2 style={{ margin: 0 }}>Add New Category</h2>
              <span
                className="close"
                onClick={closeModal}
                style={{ cursor: "pointer", fontSize: "24px", fontWeight: "bold" }}
              >
                &times;
              </span>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group" style={{ marginBottom: "20px" }}>
                <label htmlFor="categoryName" style={{ display: "block", marginBottom: "8px" }}>
                  Category Name
                </label>
                <input
                  type="text"
                  id="categoryName"
                  name="categoryName"
                  required
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "12px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    fontSize: "14px",
                    fontFamily: "'DM Sans', sans-serif",
                    marginBottom: "10px",
                    boxSizing: "border-box",
                  }}
                />
              </div>
              <div className="form-group" style={{ marginBottom: "40px" }}>
                <label htmlFor="stylePreference" style={{ display: "block", marginBottom: "8px" }}>
                  Select Style Preference:
                </label>
                <select
                  id="stylePreference"
                  name="stylePreference"
                  value={stylePreference}
                  onChange={(e) => setStylePreference(e.target.value)}
                  style={{
                    display: "block",
                    marginBottom: "10px",
                    fontWeight: "bold",
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize: "16px",
                  }}
                >
                  {predefinedStylePreferences.map((preference) => (
                    <option key={preference} value={preference}>
                      {preference}
                    </option>
                  ))}
                </select>
              </div>
              <div className="modal-actions" style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                <button
                  type="button"
                  className="cancel-button"
                  onClick={closeModal}
                  style={{
                    padding: "10px 20px",
                    borderRadius: "4px",
                    border: "none",
                    cursor: "pointer",
                    backgroundColor: "#090909",
                    color: "#dfdfdf",
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="submit-button"
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "#090909",
                    color: "#dfdfdf",
                    borderRadius: "4px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutRequest: actions.auth.logout,
      stopLoadingRequest: actions.loader.stopLoading,
      startLoadingRequest: actions.loader.startLoading,
      activateModal: actions.modal.activateModal,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(CategoryPage);
